import http from "@/http";

// ###  部门列表
//  http://base.leubao.com/api/dept/list
export const getDeptList = {
  p: "/api/dept/list",
  r: data => {
    return http({
      url: "/api/dept/list",
      method: "get",
      data
    });
  }
};
// ### 获取部门格式数据
// http://base.leubao.com/api/dept/handle_tree
export const getDeptTree = {
  p: "/api/dept/handle_tree",
  r: data => {
    return http({
      url: "/api/dept/handle_tree",
      method: "post"
    });
  }
};
// ###  部门详细信息
//  http://base.leubao.com/api/dept/details/100
export const getDeptInfo = {
  p: "/api/dept/details",
  r: data => {
    return http({
      url: "/api/dept/details/" + data.id,
      method: "get"
    });
  }
};

// ###  新增部门
//  http://base.leubao.com/api/dept/add
export const addDept = {
  p: "/api/dept/add",
  r: data => {
    return http({
      url: "/api/dept/add",
      method: "post",
      data
    });
  }
};
// ###  修改部门
//  http://base.leubao.com/api/dept/edit
export const editDept = {
  p: "/api/dept/edit",
  r: data => {
    return http({
      url: "/api/dept/edit",
      method: "post",
      data
    });
  }
};

// ###  删除部门
//  http://base.leubao.com/api/dept/delete
export const deleteDept = {
  p: "/api/dept/delete",
  r: data => {
    return http({
      url: "/api/dept/delete",
      method: "post",
      data
    });
  }
};
